import React from "react";
import { Col, Container, Row} from "react-bootstrap";
import Header from "../stories/components/Header.js";
import Image from "../stories/components/Image.js";
import IllustrationExample from "../assets/illustrations/IllustrationExample.png";
import IllustrationMosaicExample from "../assets/illustrations/IllustrationMosaicExample.png";
import IllustrationExample2 from "../assets/illustrations/IllustrationExample2.png";
import IllustrationExample3 from "../assets/illustrations/IllustrationExample3.png";
import IllustrationExample4 from "../assets/illustrations/IllustrationExample4.png";
import IllustrationExample5 from "../assets/illustrations/IllustrationExample5.png";
import IllustrationExample6 from "../assets/illustrations/IllustrationExample6.png";
import IllustrationExample7 from "../assets/illustrations/IllustrationExample7.png";
import IllustrationExample8 from "../assets/illustrations/IllustrationExample8.png";
import IllustrationExample9 from "../assets/illustrations/IllustrationExample9.png";
import IllustrationExample10 from "../assets/illustrations/IllustrationExample10.png";
import AnimationsExample from "../assets/illustrations/AnimationsExample.png";



export default function IllustrationsPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header title="Mønster" lead="Mønsteret minner oss om hva vi er, nemlig fagfolk som i samspill med gode kollegaer ivaretar enkeltmennesket og miljøet." />
        <main>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <p><i>Kontakte <a href="mailto:krdon@statsforvalteren.no">Kristian Donner</a> hvis lenke for det du ønsker å laste ned ikke er tilgjengelig.</i></p>
              <h2>Menneske og miljø</h2>
              <p>
                Illustrasjonene består av former som gir assosiasjoner til mennesker, dyr og natur. Strekene møter hverandre, overlapper og skaper nye rom, der noe er fylt, noe er åpent. Slik livet er. <br /> <br /> Figurene henger sammen – som i et kretsløp, der alt henger sammen med alt og oppfordrer oss til samarbeid og samspill – på tvers av fag og avdelinger. Formene er åpne for refleksjon og tolkning. Er det et hjerte? En datamaskin? En hånd? En fugl eller fisk? Et fjell, eller kanskje en dal? Er det egentlig noe i det hele tatt? Bare kruseduller? Eller kanskje former som visualiserer energi?
              </p>
              <p>
                Figurene er laget i ulike varianter, fra enkeltelementer som kan stå alene, til større «fortellinger» som kan fylle store flater. Det finnes elementer som er tilpasset liggende format, og andre former som passer best i høydeformat. <br /> <br /> Alle figurene kan brukes «utfallende» – det vil si at det er tillatt å la et mønster forsvinne ut av formatet – det kan «kappes».
              </p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={IllustrationExample}
            alt="Eksempel på illustrasjon. Streker møter hverandre, overlapper og skaper former."
          />
          <Row className="content">
            <Col md={{ span: 8, offset: 2}}>
              <h2>
                En hovedregel
              </h2>
              <p>
                Alle figurene er laget i samme skala. Det betyr at dersom du skal bruke flere figurer på samme flate – for eksempel på flere glassruter i samme etasje, flere figurer i samme PowerPoint, eller flere figurer i en og samme trykksak, skal de ha samme skala. Det vil si: Er en av figurene i 60 prosent størrelse i forhold til originalformatet, skal alle figurene på samme flate være i 60 prosent.
              </p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={IllustrationMosaicExample}
            alt="Eksempel på sidestilte illustrasjoner. Hver illustrasjon er like stor."
          />
          <Row className="content">
            <Col md={{ span: 8, offset: 2}}>
              <h2>
                Slik velger du
              </h2>
              <p>
                Alle illustrasjonene er nummererte.
                Originalfilene har samme nummerserie.
                Det skal derfor være enkelt å bestille
                den figuren du ønsker å bruke. I
                originalmappen finnes det flere filtyper,
                tilpasset ulik bruk, slik som til trykk
                i farger med høy oppløsning, og til
                skjermbruk. Hvis du ikke vet hva som er
                riktig filtype, spør noen som vet, eller ta
                kontakt med noen i prosjektgruppen.
              </p>
              <p>
                Mønsteret kan brukes på bygninger, i interiør, på trykksaker, på digitale flater, på skilt og i artikler.
              </p>
              <p>
                Mønsteret kan brukes med alle fargene i fargepaletten.              
              </p>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={IllustrationExample2}
            alt="Eksempel på illustrasjoner i ulik størrelse plassert ved siden av hverandre"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample3}
            alt="Eksempel på sidestilte illustrasjoner."
            caption="Mønsteret kan også brukes med enkeltelement, eller satt sammen- to eller flere. Avhengig av hvilke og hvor store flater det skal brukes på."
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample4}
            alt="Eksempel på sidestilte illustrasjoner"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample5}
            alt="Illustrasjon av norgeskart"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample6}
            alt="Eksempel på sidestilte illustrasjoner med farge"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample7}
            alt="Eksempel på sidestilte illustrasjoner"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample8}
            alt="Eksempel på sidestilte illustrasjoner"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample9}
            alt="Eksempel på sidestilte illustrasjoner"
          />
          <Image
            size="medium"
            imgUrl={IllustrationExample10}
            alt="Eksempel på sidestilte illustrasjoner"
          />
          <Row className="content">
            <Col md={{ span: 8, offset: 2}}>
              <h3>Illustrasjoner</h3>
              <p><i>Lenke for illustrasjoner tar deg til Imageshop.</i></p><br />
              <p><i>For å redigere eller bearbeide .ai-filer trenger en enten Adobe Illustrator eller lignende programvare som kan åpne filen.</i></p>
            </Col>
          </Row>
          <Row className="content">
            <Col md={{ span: 1, offset: 2}}>
              <ul>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782360" target="_blank" rel="noopener noreferrer">FM_moenster_01.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782707" target="_blank" rel="noopener noreferrer">FM_moenster_02.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782708" target="_blank" rel="noopener noreferrer">FM_moenster_02_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782709" target="_blank" rel="noopener noreferrer">FM_moenster_03.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782710" target="_blank" rel="noopener noreferrer">FM_moenster_03_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782711" target="_blank" rel="noopener noreferrer">FM_moenster_04.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782712" target="_blank" rel="noopener noreferrer">FM_moenster_05.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782713" target="_blank" rel="noopener noreferrer">FM_moenster_06.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782714" target="_blank" rel="noopener noreferrer">FM_moenster_07.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782715" target="_blank" rel="noopener noreferrer">FM_moenster_08.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782717" target="_blank" rel="noopener noreferrer">FM_moenster_08_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782719" target="_blank" rel="noopener noreferrer">FM_moenster_09.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782721" target="_blank" rel="noopener noreferrer">FM_moenster_09_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782722" target="_blank" rel="noopener noreferrer">FM_moenster_10.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782723" target="_blank" rel="noopener noreferrer">FM_moenster_10_hvit.ai</a></li>
              </ul>
            </Col>
            <Col md={{ span: 1, offset: 2}}>
              <ul>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782724" target="_blank" rel="noopener noreferrer">FM_moenster_11.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782725" target="_blank" rel="noopener noreferrer">FM_moenster_11_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782726" target="_blank" rel="noopener noreferrer">FM_moenster_12.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782727" target="_blank" rel="noopener noreferrer">FM_moenster_12_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782728" target="_blank" rel="noopener noreferrer">FM_moenster_13.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782729" target="_blank" rel="noopener noreferrer">FM_moenster_14.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782731" target="_blank" rel="noopener noreferrer">FM_moenster_14_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782732" target="_blank" rel="noopener noreferrer">FM_moenster_15.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782733" target="_blank" rel="noopener noreferrer">FM_moenster_15_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782734" target="_blank" rel="noopener noreferrer">FM_moenster_16.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782735" target="_blank" rel="noopener noreferrer">FM_moenster_16_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782736" target="_blank" rel="noopener noreferrer">FM_moenster_17.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782737" target="_blank" rel="noopener noreferrer">FM_moenster_17_hvit.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782738" target="_blank" rel="noopener noreferrer">FM_moenster_18.ai</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782739" target="_blank" rel="noopener noreferrer">FM_moenster_18_hvit.ai</a></li>

              </ul>
            </Col>
          </Row>
          <Row className="content">
            <Col md={{ span: 8, offset: 2}}>
              <h2>
                Animasjoner
              </h2>
              <p>
              Flere embeter bruker levende bilder i sitt kommunikasjonsarbeid. Deler av mønsteret «Menneske og miljø» er animert. Animasjonene kan for eksempel brukes til å avslutte en Power Point-presentasjon og brukes i videoproduksjon (direktesendinger og annet innhold).
              </p>
              <p> 
                Animasjonene finnes i tre størrelser, altså tre forskjellige oppløsninger. Oppløsningene er et uttrykk for hvor mange piksler et bilde inneholder. Oppløsningene er oppgitt i for eksempel 1920x1080. Det vill si 1920 piksler bredt og 1080 piksler høyt (HD-oppløsning).  
              </p>
              <p>
                1080x1080 er kvadratisk og passer formatet som brukes på Instagram og i noen videoer på facebook, blant annet.
                Mønsteret er tenkt utfallende, derfor finnes også en større variant (2160x2160) som kan være utfallende og zoomes inn i uten at det går utover kvaliteten på streken. Zoomer du inn på animasjonene 1080x1080 og 1920x1080 vil streken bli pikslete og ikke være skarp.
                Video 2160x2160
              </p>
              <h3>Originaler video 1080x1080</h3>
              <ul>
                <li><a href="https://v.imgi.no/yuekzucqu2" download>FM_dame_animasjon_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/6salaqakyb" download>FM_dame_animasjon_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/844gabhubp" download>FM_fugl_animasjon_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/qjqnfgq4nv" download>FM_fugl_animasjon_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/hrabec78rd" download>FM_kart_animasjon_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/pj2vyyxk7e" download>FM_kart_animasjon_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/k88ylpnhkt" download>FM_samtale_animasjon_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/m774j3ppxf" download>FM_samtale_animasjon_Pc.mov</a></li>
              </ul>
              <h3>Originaler video 1920x1080</h3>
              <ul>
                <li><a href="https://v.imgi.no/e52rx38eht" download>FM_dame_animasjon_wide_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/ph4227dyc4" download>FM_dame_animasjon_wide_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/jezvn2ustn" download>FM_fugl_animasjon_wide_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/8gxzpuxtjd" download>FM_fugl_animasjon_wide_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/pfr5ud32ym" download>FM_kart_animasjon_wide_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/m68cyadec5" download>FM_kart_animasjon_wide_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/gns4ugsdke" download>FM_samtale_animasjon_wide_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/hrn7ndu5ak" download>FM_samtale_animasjon_wide_Pc.mov</a></li>
              </ul>
              <h3>Originaler video 2160x2160</h3>
              <ul>
                <li><a href="https://v.imgi.no/mhd25ltl4s" download>FM_dame_animasjon_stor_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/87c5vya8am" download>FM_dame_animasjon_stor_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/7khya2av3m" download>FM_fugl_animasjon_stor_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/txpsd5rbxt" download>FM_fugl_animasjon_stor_Pc.mov</a></li>
                <li><a href="https://v.imgi.no/q8ttzjmjcd" download>FM_kart_animasjon_stor_Mac.mov</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782629" download>FM_kart_animasjon_stor_Pc.mov</a></li>
                <li><a href="https://statsforvalteren.imageshop.no/1192463/Detail/Index/2782630" download>FM_samtale_animasjon_stor_Mac.mov</a></li>
                <li><a href="https://v.imgi.no/4rakdnvrbt" download>FM_samtale_animasjon_stor_Pc.mov</a></li>
              </ul>
            </Col>
          </Row>
          <Image
            size="medium"
            imgUrl={AnimationsExample}
            alt="Eksempel på animasjoner"
          />
        </main>
      </article>
    </Container>
  );
}
